/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TetraDto } from '../../models/tetra-dto';

export interface ApiTetraOperativaGet$Params {
    /**
     * data di inizio - date
     */
    da: string;

    /**
     * data di fine - date
     */
    a: string;
}

export function apiTetraOperativaGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiTetraOperativaGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<TetraDto>>> {
    const rb = new RequestBuilder(rootUrl, apiTetraOperativaGet.PATH, 'get');
    if (params) {
        rb.query('da', params.da, {});
        rb.query('a', params.a, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<TetraDto>>;
        }),
    );
}

apiTetraOperativaGet.PATH = '/api/tetra/operativa';
